import {
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Collapse,
  FormControlLabel,
  Grid,
  IconButton,
  MenuItem,
  Modal,
  Select,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import { memo, useCallback, useEffect, useRef, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CloseIcon from "@mui/icons-material/Close";
import { IoIosAlert } from "react-icons/io";
import { Postrequestcall } from "../../../request/Postrequest";
import {
  DELETE_CLIENT_TIMESHEET_JOB_IMAGES,
  FETCH_CLIENT_TIMESHEET_JOBS_V2,
  SAVE_CLIENT_TIMESHEET_JOB_IMAGES,
  SAVE_CLIENT_TIMESHEETS,
  UPDATE_CLOCK_TIME,
  UPDATE_CLIENT_TIMESHEET_HOUR_NOTES
} from "../../../constant/Apipath";
import { useSelector } from "react-redux";
import moment from "moment";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { BIGrey, BILightGrey } from "../../../assets/helpers";
import Getcurrentlocation from "../../../common/Getcurrentlocation";
import Loader from "../../../common/Loader";
import AddIcon from "@mui/icons-material/Add";
import PictureViewer from "../../../common/PictureViewer";
import { ClientEnglishFallback } from "../../constant/ClientEnglishFallback";
import ConfirmModal from "../promptModal/ConfirmModal";

let CLIENT_COLOR = "#000000";

export default function ClientViewEmployeeTimeSheet({
  isOpen,
  onClose,
  item,
  setReviewdata,
  setOpenreview,
  setIsrefresh
}) {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  CLIENT_COLOR = selectedClientData?.AccentColor;

  const TOKEN = loginData?.accessToken;
  const USER_ID = loginData?.userInformation?.UserId;

  const {
    TEXT_ACTIVITIES,
    BUTTON_SUBMIT,
    TEXT_IN,
    TEXT_OUT,
    TEXT_HOURS,
    TEXT_YOUR_FOREMAN_TEXT,
    TEXT_CREATED_TIMESHEET_FOR_YOU,
    TEXT_INFORMATION_NECESSARY,
    TEXT_CLOCK_IN,
    TEXT_CLOCK_OUT,
    TEXT_MILEAGE_OPTIONAL,
    TEXT_DETAIL_MODAL_KM,
    TEXT_MI,
    PLACEHOLDER_SOMETHING,
    DISACRD_CHANGES,
    TEXT_WILL_BE_LOST,
    BUTTON_DISCARD,
    BUTTON_SAVE
  } = ClientEnglishFallback?.AddTimesheetModal(multiLanguageData?.AddTimesheetModal || {});

  const { CLOCK_OUT_CURRENT_JOB, TEXT_CONTINUE } = ClientEnglishFallback.ConfirmModal(
    multiLanguageData?.ConfirmModal || {}
  );

  const [timeSheetData, setTimeSheetData] = useState({});
  const [mileage, setMileage] = useState(null);
  const [mileageUnit, setMileageUnit] = useState("km");
  const [activityIndex, setActivityindex] = useState(null);
  const [deleteImageList, setDeleteImageList] = useState([]);

  const [disableSaveBtn, setDisableSaveBtn] = useState(false);

  const [loader, setLoader] = useState(false);

  const [imageIndex, setImageIndex] = useState(0);
  const [pictureViewerOpen, setPictureViewerOpen] = useState(false);
  const [discardDialogOpen, setDiscardDialogOpen] = useState(false);

  const [pictures, setPictures] = useState([]);

  const [clockIn, setClockin] = useState(null);
  const [clockOut, setClockout] = useState(null);

  const [hours, setHours] = useState({});
  const [hoursIndex, setHoursIndex] = useState(null);
  const [clockInConfirm, setClockInConfirm] = useState(false);

  const imgRef = useRef(null);

  useEffect(() => {
    const getData = async () => {
      setLoader(true);
      await getTimeSheetData(true);
    };
    if (isOpen) {
      getData();
    }
    return () => {
      setActivityindex(null);
    };
  }, [isOpen]);

  useEffect(() => {
    checkSubmitBtnStatus();
    return () => { };
  }, [timeSheetData]);

  const getTimeSheetData = async (firstTimeApiCall) => {
    try {
      const timeSheetJobObject = {
        PageNr: 1,
        FullSearch: "",
        UserId: USER_ID,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [{ ClientTimesheetId: item?.id }]
      };
      const getResponse = await Postrequestcall(
        FETCH_CLIENT_TIMESHEET_JOBS_V2,
        timeSheetJobObject,
        TOKEN,
        false
      );

      if (getResponse.status === 200) {
        if (getResponse?.data?.data?.length > 0) {
          let getData = getResponse?.data?.data[0];
          if (firstTimeApiCall === true) {
            setTimeSheetData(getData);
          } else {
            const updatedTimesheetHoursList = timeSheetData.timesheetHoursList?.map((hoursItem) => {
              let newDataTimeSheetHoursList = getData?.timesheetHoursList;
              const updatedItem = newDataTimeSheetHoursList.find(
                (newItem) => newItem.id === hoursItem.id
              );
              if (updatedItem) {
                return {
                  ...hoursItem,
                  clockInTime: updatedItem?.clockInTime,
                  clockOutTime: updatedItem?.clockOutTime,
                  hours: updatedItem?.hours,
                  clockInLatitude: updatedItem?.clockInLatitude ?? 0,
                  clockOutLatitude: updatedItem?.clockOutLatitude ?? 0,
                  clockInLongitude: updatedItem?.clockInLongitude ?? 0,
                  clockOutLongitude: updatedItem?.clockOutLongitude ?? 0
                };
              }
              return hoursItem;
            });
            setTimeSheetData({ ...timeSheetData, timesheetHoursList: updatedTimesheetHoursList });
            const isRefresh = updatedTimesheetHoursList
              .filter((item) => item?.clientEmployeeId === selectedClientData?.ClientEmployeeId)
              .some((item) => item.clockInTime === "00:00" && item.clockOutTime === "00:00");
            setIsrefresh(!isRefresh);
          }
          let currentClientEmployeeDetails = getData?.timesheetEmployeesList?.filter(
            (emp) => emp?.clientEmployeeId === selectedClientData?.ClientEmployeeId
          );
          setMileage(
            firstTimeApiCall === true
              ? (currentClientEmployeeDetails?.[0]?.mileage ?? null)
              : mileage
          );
          setMileageUnit(
            firstTimeApiCall === true
              ? (currentClientEmployeeDetails?.[0]?.mileageUnit ?? "km")
              : mileageUnit
          );
        }
      }
      // setTimeout(() => {
      //     setIsRefreshing(false);
      // }, 500);
    } catch (e) {
      console.log("getTimeSheetData-> Error Fetching Client Timesheet Job: ", e);
      //setIsRefreshing(false);
    } finally {
      setClockin(null);
      setClockout(null);
      setHoursIndex(null);
      setLoader(false);
    }
  };

  const setUserMilage = (event) => {
    let formattedMileage = "";
    const sanitizedText = event.target.value?.replace(/[^\d.]/g, "").replace(/(\..*)\./g, "$1");
    if (sanitizedText.includes(".")) {
      const [integer, decimal] = sanitizedText.split(".");
      formattedMileage = `${integer.slice(0, 3)}.${decimal.slice(0, 1)}`;
    } else if (sanitizedText.length <= 3) {
      formattedMileage = sanitizedText;
    } else {
      formattedMileage = `${sanitizedText.slice(0, 3)}.${sanitizedText.slice(3, 4)}`;
    }
    setMileage(formattedMileage);
    let getUpdated = timeSheetData?.timesheetEmployeesList?.map((emp) => {
      if (emp.clientEmployeeId === selectedClientData?.ClientEmployeeId) {
        return {
          ...emp,
          mileage: formattedMileage
        };
      }
      return emp;
    });
    setTimeSheetData({ ...timeSheetData, timesheetEmployeesList: getUpdated });
  };

  const setUserMilageUnit = (e) => {
    let getUpdated = timeSheetData?.timesheetEmployeesList?.map((emp) => {
      if (emp.clientEmployeeId === selectedClientData?.ClientEmployeeId) {
        return {
          ...emp,
          mileageUnit: e.target.value === 1 ? "km" : "mi"
        };
      }
      return emp;
    });
    setTimeSheetData({ ...timeSheetData, timesheetEmployeesList: getUpdated });
    setMileageUnit(e.target.value === 1 ? "km" : "mi");
  };

  const handelInputClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    imgRef.current.click();
  };

  const handleRemoveImage = (e, actIndex, picIndex) => {
    e.stopPropagation();
    const activity = timeSheetData.timesheetActivitiesList[actIndex];
    const removedImage = activity?.pictureList?.[picIndex];

    const updatedPictureList = activity?.pictureList?.filter((item, index) => index !== picIndex);
    const updatedActivities = timeSheetData.timesheetActivitiesList?.map((item, index) => {
      if (index === actIndex) {
        return {
          ...item,
          pictureList: updatedPictureList
        };
      }
      return item;
    });

    if (removedImage && !removedImage.isNew && removedImage.id) {
      setDeleteImageList((prev) => [...prev, removedImage]);
    }

    setTimeSheetData({ ...timeSheetData, timesheetActivitiesList: updatedActivities });
  };

  const handelImageChange = (event, act) => {
    let files = Array.from(event.target.files);
    files = files.filter((file) => file.type.startsWith("image/"));
    const newImages = [...act?.pictureList];
    for (let i = 0; i < files.length; i++) {
      newImages.push({
        isNew: true,
        file: files[i]
      });
    }
    const getUpdatedlist = timeSheetData.timesheetActivitiesList?.map((item, index) => {
      if (item.id === act.id) {
        return {
          ...item,
          pictureList: newImages
        };
      }
      return item;
    });
    setTimeSheetData({ ...timeSheetData, timesheetActivitiesList: getUpdatedlist });
    event.target.value = "";
  };

  const getForemanName = useCallback(() => {
    try {
      const name = timeSheetData?.timesheetHoursList
        ?.map((em) => {
          if (em?.clientEmployeeId == selectedClientData?.ClientEmployeeId) {
            return em?.foremanClientEmployeeName;
          }
        })
        .filter((x) => x != undefined);

      return name !== undefined ? name[0] : "";
    } catch (e) {
      console.log("getForemanName-> Error Getting Foreman Name: ", e);
    }
  }, [timeSheetData]);

  const accordianChange = (e, index) => {
    e.stopPropagation();
    e.preventDefault();
    if (activityIndex === index) {
      setActivityindex(null);
    } else {
      setActivityindex(index);
    }
  };

  const onClockBtnPressed = async (props) => {
    const { hours, type, index } = props;
    switch (type) {
      case "CLOCK_IN":
        if (clockIn === null) {
          // First we need to check is it in timesheetHoursList list Clock In is present or not
          const isCurrentempClockIn = timeSheetData.timesheetHoursList
            .filter((item) => item?.clientEmployeeId === selectedClientData?.ClientEmployeeId)
            .some((item) => item.clockInTime !== "00:00" && item.clockOutTime === "00:00");
          if (isCurrentempClockIn) {
            setHours(hours);
            setHoursIndex(index);
            setClockInConfirm(true);
          } else {
            setClockin(index);
            await saveClockData({ id: hours?.id, type });
          }
        }
        break;
      case "CLOCK_OUT":
        await saveClockData({ id: hours?.id, type });
        break;
      default:
        break;
    }
  };

  const onConfirmClockIn = async () => {
    try {
      setClockInConfirm(false);
      const isPrevempClockIn = timeSheetData.timesheetHoursList
        .filter((item) => item?.clientEmployeeId === selectedClientData?.ClientEmployeeId)
        .filter((item) => item?.clockInTime !== "00:00" && item?.clockOutTime === "00:00");
      if (isPrevempClockIn?.length !== 0) {
        setClockin(hoursIndex);
        let getPrevHours = isPrevempClockIn[0];
        await Promise.all([
          saveClockData({ id: getPrevHours?.id, type: "CLOCK_OUT" }),
          saveClockData({ id: hours?.id, type: "CLOCK_IN" })
        ]);
      }
    } catch (error) { }
  };

  const saveClockData = async (props) => {
    const { id, type } = props;
    const currentLocation = await Getcurrentlocation();

    let timeSheetHours = timeSheetData.timesheetHoursList
      ?.filter((hr) => hr.id === id)
      ?.map((hr) => {
        return hr;
      }) || [];
    try {
      const timeSheetPayload = {
        UserId: USER_ID,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            id: Number(id),
            modifiedBy: USER_ID
          }
        ]
      };
      if (type == "CLOCK_IN") {
        timeSheetPayload.SaveList[0]["clockInTime"] = moment().format("HH:mm");
        timeSheetPayload.SaveList[0]["clockInLatitude"] = currentLocation.lat;
        timeSheetPayload.SaveList[0]["clockInLongitude"] = currentLocation.lng;
        timeSheetPayload.SaveList[0]["Notes"] = timeSheetHours[0]?.notes;

        //
        timeSheetPayload.SaveList[0]["clockOutTime"] = moment(
          timeSheetHours[0]?.clockOutTime,
          "HH:mm a"
        ).format("HH:mm");
        timeSheetPayload.SaveList[0]["clockOutLatitude"] = timeSheetHours[0]?.clockOutLatitude;
        timeSheetPayload.SaveList[0]["clockOutLongitude"] = timeSheetHours[0]?.clockOutLongitude;
        timeSheetPayload.SaveList[0]["statusId"] = 4;
      }

      if (type == "CLOCK_OUT") {
        timeSheetPayload.SaveList[0]["clockOutTime"] = moment().format("HH:mm");
        timeSheetPayload.SaveList[0]["clockOutLatitude"] = currentLocation.lat;
        timeSheetPayload.SaveList[0]["clockOutLongitude"] = currentLocation.lng;
        timeSheetPayload.SaveList[0]["Notes"] = timeSheetHours[0]?.notes;
        //
        timeSheetPayload.SaveList[0]["clockInTime"] = moment(
          timeSheetHours[0]?.clockInTime,
          "HH:mm a"
        ).format("HH:mm");
        timeSheetPayload.SaveList[0]["clockInLatitude"] = timeSheetHours[0]?.clockInLatitude;
        timeSheetPayload.SaveList[0]["clockInLongitude"] = timeSheetHours[0]?.clockInLongitude;
        timeSheetPayload.SaveList[0]["statusId"] = 1;
      }
      const response = await Postrequestcall(UPDATE_CLOCK_TIME, timeSheetPayload, TOKEN, false);
      if (response.status) {
        getTimeSheetData(false);
      }
      // setTimeout(() => {
      //     setIsRefreshing(false);
      // }, 1000);
    } catch (e) {
      //setIsRefreshing(false);
      console.log("saveClockData-> Error When Upating Client Crew ClockIn Time: ", e);
    } finally {
    }
  };

  const getUserHoursList = () => {
    return timeSheetData?.timesheetHoursList
      .map((hr) => {
        if (hr.clientEmployeeId == selectedClientData?.ClientEmployeeId) {
          return hr;
        }
      })
      .filter((x) => x != undefined);
  };

  // #. Add note to Timesheet hours list:
  const addNotesHour = (e, hours) => {
    e.preventDefault();
    e.stopPropagation();
    let inputValue = e.target.value.replace(/^[^A-Za-z0-9]+/, "");
    const updatedHoursList = timeSheetData.timesheetHoursList?.map((hr) => {
      if (hr.id === hours?.id) {
        return {
          ...hr,
          notes: inputValue
        };
      }
      return hr;
    });

    setTimeSheetData({
      ...timeSheetData,
      timesheetHoursList: updatedHoursList
    });
  };

  const isTimeZero = (time) => {
    return time === "00:00";
  };

  // CHECK SAVE BUTTON STATUS :
  const checkSubmitBtnStatus = () => {
    try {
      let a = [];
      timeSheetData?.timesheetHoursList?.map((hr) => {
        if (hr.clientEmployeeId == selectedClientData?.ClientEmployeeId) {
          if (
            hr.clockInTime &&
            hr.clockInTime !== "00:00" &&
            hr.clockInTime.trim() !== "00:00" &&
            hr.clockOutTime &&
            hr.clockOutTime !== "00:00" &&
            hr.clockOutTime.trim() !== "00:00"
          ) {
            a.push("true");
          } else {
            a.push("false");
          }
        }
      });
      const allTrueOrFalse = a.every((value) => value === "true");
      setDisableSaveBtn(allTrueOrFalse);
    } catch (e) {
      console.log("checkSubmitBtnStatus-> Error When Checking Submit Button Status: ", e);
    }
  };

  // // CONDITION 1 : Check for both clock have time ;
  let checkBothTimeForOneClock = Object.values(timeSheetData).some(
    (item) => item.clockInTime !== "00:00" && item.clockOutTime !== "00:00"
  );
  // // CONDITION 2 : check for any one clock have check-in time
  let checkInTimeForOneClock = Object.values(timeSheetData).some(
    (item) => item.clockInTime !== "00:00"
  );

  const getudFieldsString = (data) => {
    try {
      if (!data?.length) {
        return "";
      }

      const fieldsObject = data.reduce((acc, item) => {
        acc[item.id] = item.value === "false" ? 0 : 1;
        return acc;
      }, {});

      return JSON.stringify(fieldsObject);
    } catch (error) {
      console.error("getudFieldsString-> Error processing UD fields:", error);
      return "";
    }
  };
  const mileageconverter = () => {
    try {
      return parseFloat(mileage);
    } catch (error) {
      console.log("mileageconverter-> Error When Converting Mileage: ", JSON.stringify(error, null, 2));
      return 0;
    }
  };

  const deleteActivityImages = async (props) => {

    try {
      const obj = {
        UserId: USER_ID,
        ReturnRecordId: false,
        ReturnRecordError: true,
        SoftDelete: true,
        DeleteList: props
      };
      await Postrequestcall(DELETE_CLIENT_TIMESHEET_JOB_IMAGES, obj, TOKEN);
    } catch (e) {
      console.log("deleteActivityImages-> Error When Deleting Client Timesheet Job Images: ", e);
    }
  };
  const saveInitialData = useCallback(async () => {
    try {
      let ts = timeSheetData || {};
      if (timeSheetData?.timesheetActivitiesList) {
        for (const item of timeSheetData.timesheetActivitiesList) {
          if (item.pictureList && item.pictureList.length > 0) {
            for (let index = 0; index < item.pictureList.length; index++) {
              const image = item.pictureList[index];
              if (image.isNew && image.file) {
                const formData = new FormData();
                formData.append("Id", 0);
                formData.append("ClientTimesheetJobId", ts?.id);
                formData.append("ClientJobId", item?.clientJobId);
                formData.append("ClientActivityId", item.clientActivityId);
                formData.append("FileName", image.file, image.file.name || `image${index}.jpg`);
                formData.append("ModifiedBy", USER_ID);
                formData.append("ClientTimesheetId", ts?.clientTimesheetId);
                formData.append("ClientEmployeeId", selectedClientData?.ClientEmployeeId);
                try {
                  await Postrequestcall(SAVE_CLIENT_TIMESHEET_JOB_IMAGES, formData, TOKEN, true);
                } catch (imgErr) {
                  console.log("saveInitialData-> Error When Saving Client Timesheet Job Images: ", imgErr);
                }
              }
            }
          }
        }
      }

      // if (deleteImageArray?.length > 0) {
      //     deleteActivityImages(deleteImageArray);
      // }

      const emp = timeSheetData.timesheetEmployeesList?.find(
        (item) => item.clientEmployeeId === selectedClientData?.ClientEmployeeId
      );

      if (!emp) return;

      let empObj = {
        Id: emp.id,
        ClientJobId: emp.clientJobId,
        ClientEmployeeId: emp.clientEmployeeId,
        Mileage: mileageconverter(mileage),
        MileageUnit: mileageUnit,
        UDFields: getudFieldsString(emp?.udFieldsList),
        Deleted: false
      };

      let JOBlist = {
        Id: timeSheetData.id,
        ClientJobId: timeSheetData.clientJobId,
        Notes: timeSheetData.notes,
        UDFields: getudFieldsString(timeSheetData.udFieldsList),
        Deleted: false
      };

      let payload = {
        Id: timeSheetData.clientTimesheetId,
        Date: timeSheetData.date,
        DateSubmitted: timeSheetData.dateSubmitted,
        StatusId: 4,
        TypeId: timeSheetData.typeId,
        ClientId: timeSheetData.clientId,
        Deleted: false,
        TimeSheetJobList: [JOBlist],
        EmployeeList: [empObj],
        TimesheetHoursList: [],
        ActivityList: []
      };

      const save_TimeSheet_Object = {
        UserId: USER_ID,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [payload]
      };

      await Postrequestcall(SAVE_CLIENT_TIMESHEETS, save_TimeSheet_Object, TOKEN);
    } catch (error) {
      console.log("saveInitialData-> Error When Saving Client Timesheet :", JSON.stringify(error, null, 2));
    } finally {
      setClockin(null);
      setClockout(null);
      setHoursIndex(null);
      setLoader(false);
    }
  }, [
    selectedClientData?.ClientEmployeeId,
    // deleteImageArray,
    timeSheetData?.timesheetHoursList,
    mileage,
    mileageUnit,
    timeSheetData,
    USER_ID
  ]);

  const saveComments = async () => {
    try {
      const commentsData = [];
      const userHours =
        timeSheetData?.timesheetHoursList?.filter(
          (hr) => hr.clientEmployeeId === selectedClientData?.ClientEmployeeId
        ) || [];

      userHours.forEach((hr) => {
        if (hr.notes && hr.notes.trim() !== "") {
          commentsData.push({
            Notes: hr.notes,
            TimesheetHourId: hr?.id
          });
        }
      });

      if (commentsData.length === 0) return;

      const finalData = {
        UserId: USER_ID,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: commentsData
      };
      await Postrequestcall(UPDATE_CLIENT_TIMESHEET_HOUR_NOTES, finalData, TOKEN);
    } catch (error) {
      console.log("error saveComments", JSON.stringify(error, null, 2));
    }
  };

  const onSubmitPressed = (e) => {
    e.preventDefault();
    saveComments();
    onClose();
    setReviewdata(timeSheetData);
    setOpenreview(true);
  };

  const onEmployeeUdfieldChange = (e, empIndex, udIndex) => {
    let updatedData = { ...timeSheetData };
    let getEmployee = updatedData?.timesheetEmployeesList?.map((item, eindex) => {
      if (empIndex === eindex) {
        let udFieldJsonString = {};
        let udList = item.udFieldsList.map((item, index) => {
          if (udIndex === index) {
            return {
              ...item,
              value: e?.target?.value === "false" ? "true" : "false"
            };
          }
          return item;
        });
        udList.forEach((field) => {
          let isChecked = field.value === "true";
          if (isChecked) {
            udFieldJsonString[field?.id] = 1;
          } else {
            udFieldJsonString[field?.id] = 0;
          }
        });
        let udFieldsString = JSON.stringify(udFieldJsonString);
        return {
          ...item,
          udFieldsList: udList,
          udFields: udFieldsString
        };
      }
      return item;
    });
    setTimeSheetData({ ...updatedData, timesheetEmployeesList: getEmployee });
  };

  const onClosetimesheet = async () => {
    try {
      if (deleteImageList.length > 0) {
        await deleteActivityImages(deleteImageList);
        setDeleteImageList([]);
      }
      await saveInitialData();
      onClose();
    } catch (error) {
      alert("Failed to save timesheet data. Please try again.");
    }
  };

  const ImgUrl = (file) => {
    try {
      let url = URL?.createObjectURL(file);
      return url;
    } catch (error) {
      return file;
    }
  };

  const getPictures =
    pictures?.map((item) => {
      return {
        src: item?.fileUrl || ImgUrl(item?.file)
      };
    }) || [];

  const handleCloseIconClick = () => {
    setDiscardDialogOpen(true);
  };

  const handleModalClose = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      setDiscardDialogOpen(true);
    } else {
      setDiscardDialogOpen(true);
    }
  };

  const handleDiscard = () => {
    setDiscardDialogOpen(false);
    setDeleteImageList([]);
    onClose();
  };

  const handleSaveAndClose = async () => {
    setDiscardDialogOpen(false);
    setLoader(true);
    try {
      if (deleteImageList.length > 0) {
        await deleteActivityImages(deleteImageList);
        setDeleteImageList([]);
      }
      await saveComments();
      await saveInitialData();
    } catch (error) {
    } finally {
      setLoader(false);
      onClose();
    }
  };

  return (
    <>
      <PictureViewer
        isOpen={pictureViewerOpen}
        viewerIndex={imageIndex}
        pictures={getPictures}
        onClose={() => setPictureViewerOpen(false)}
      />

      <ConfirmModal
        isOpen={clockInConfirm}
        onClose={() => setClockInConfirm(false)}
        isHelpModal={false}
        title={CLOCK_OUT_CURRENT_JOB}
        confirmButtonText={TEXT_CONTINUE}
        onConfirm={() => {
          onConfirmClockIn();
        }}
      />

      <Modal
        open={isOpen}
        onClose={handleModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box className="client-modal-responsive">
          <Stack sx={{ display: "flex",  justifyContent: "space-between", alignItems: "center" }}  direction={"row"}>
            <IconButton size="small" onClick={handleCloseIconClick}>
              <CloseIcon />
            </IconButton>
          </Stack>
          <Dialog open={discardDialogOpen} onClose={() => setDiscardDialogOpen(false)}>
            <DialogTitle>{DISACRD_CHANGES}</DialogTitle>
            <DialogContent>{TEXT_WILL_BE_LOST}</DialogContent>
            <DialogActions>
              <Button
                onClick={handleDiscard}
                sx={{
                  boxShadow: "none",
                  color: "#000",
                  backgroundColor: BILightGrey,
                  textTransform: "none",
                  borderRadius: "8px",
                  width: "100px"
                }}>
                {BUTTON_DISCARD}
              </Button>
              <Button
                onClick={handleSaveAndClose}
                color="primary"
                variant="contained"
                sx={{
                  boxShadow: "none",
                  color: "white",
                  backgroundColor: CLIENT_COLOR,
                  textTransform: "none",
                  borderRadius: "8px",
                  width: "100px"
                }}>
                {BUTTON_SAVE}
              </Button>
            </DialogActions>
          </Dialog>
          <Stack
            sx={{
              maxHeight: "70vh",
              overflowY: loader ? "unset" : "auto",
              scrollbarWidth: "none"
            }}>
            {loader ? (
              <Loader />
            ) : (
              <>
                <Stack className="forman-card" sx={{ margin: "10px 0px" }}>
                  <IoIosAlert />
                  <Stack>
                    <Typography>
                      {TEXT_YOUR_FOREMAN_TEXT}{" "}
                      <Typography variant="h6" sx={{ display: "inline" }}>
                        {getForemanName() === "" ? "" : ("(" + getForemanName() + ")" ?? "")}{" "}
                      </Typography>
                      {TEXT_CREATED_TIMESHEET_FOR_YOU}
                    </Typography>
                    <Typography>{TEXT_INFORMATION_NECESSARY}</Typography>
                  </Stack>
                </Stack>
                <Stack sx={{ gap: 1 }} >
                  <Typography
                    style={{
                      color: BIGrey
                    }}
                    variant="h6">
                    {`${moment(timeSheetData?.date).format("MMMM DD, YYYY")}`}
                  </Typography>
                  <Typography>{`${timeSheetData?.clientJobCode} - ${timeSheetData?.clientJobName}`}</Typography>
                </Stack>
                <Stack sx={{ margin: "10px 0px" }}>
                  <Typography>{TEXT_MILEAGE_OPTIONAL}</Typography>
                  <Stack sx={{ gap: '10px' }} direction={"row"} >
                    <TextField
                      hiddenLabel
                      size="small"
                      value={mileage?.toString()}
                      onChange={(e) => setUserMilage(e)}
                      name="mileage"
                      style={{
                        width: "80px",
                        borderColor: "transparent",
                        backgroundColor: "rgba(0, 0, 0, 0.08)",
                        borderRadius: "5px"
                      }}
                      sx={{
                        "& fieldset": { border: "none" }
                      }}
                    />
                    <Select
                      size="small"
                      style={{
                        backgroundColor: "rgba(0, 0, 0, 0.08)",
                        borderColor: "transparent"
                      }}
                      sx={{
                        "& fieldset": { border: "none" }
                      }}
                      value={mileageUnit === "km" ? 1 : 2}
                      onChange={(e) => setUserMilageUnit(e)}>
                      <MenuItem value={1}>{TEXT_DETAIL_MODAL_KM}</MenuItem>
                      <MenuItem value={2}>{TEXT_MI}</MenuItem>
                    </Select>
                  </Stack>
                </Stack>

                {timeSheetData?.timesheetEmployeesList?.map(
                  (emp, empIndex) =>
                    emp?.clientEmployeeId === selectedClientData?.ClientEmployeeId &&
                    emp?.udFieldsList?.map((udField, udIndex) => (
                      <Grid size={12}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              value={udField?.value}
                              checked={udField?.value === "false" ? false : true}
                              onChange={(e) => onEmployeeUdfieldChange(e, empIndex, udIndex)}
                              sx={{
                                color: CLIENT_COLOR,
                                "&.Mui-checked": {
                                  color: CLIENT_COLOR
                                }
                              }}
                            />
                          }
                          label={udField?.label}
                        />
                      </Grid>
                    ))
                )}
                <Typography sx={{ margin: "10px 0px",  fontWeight: "bold" }} >
                  {TEXT_ACTIVITIES}
                </Typography>
                {timeSheetData?.timesheetActivitiesList?.map((act, index) => (
                  <div
                    key={index}
                    className="pagelist-content timesheetActivity"
                    style={{
                      border: "1px solid #E0E0E0",
                      borderRadius: "12px",
                      marginBottom: "10px",
                      backgroundColor: "white",
                    }}>
                    {/* Clickable header */}
                    <div
                      onClick={(e) => accordianChange(e, index)}
                      style={{
                        padding: "10px 12px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "flex-start",
                        justifyContent: "space-between"
                      }}>
                      <Stack sx={{ flex: 1, flexDirection: "column", display: "flex", gap: "10px", width: "100%" }}>
                        <Typography variant="h6" sx={{ fontWeight: 500 }}>
                          {act?.clientJobActivityCode} - {act?.clientJobActivityName}
                        </Typography>
                        {act?.udFieldsList?.length > 0 && (
                          <Stack sx={{ gap: '10px' }} direction={"row"} >
                            {act?.udFieldsList.map(
                              (data, index) =>
                                data.value == "true" && (
                                  <Chip
                                    key={index}
                                    size="small"
                                    sx={{ borderRadius: "5px" }}
                                    label={data?.label}
                                  />
                                )
                            )}
                          </Stack>
                        )}
                        {getUserHoursList().map(
                          (hr, hr_index) =>
                            hr.clientJobActivityId === act.clientActivityId && (
                              <Stack sx={{ gap: '25px' }} key={hr_index} direction={"row"} textAlign={"start"} >
                                <Stack>
                                  <Typography sx={{ color: BIGrey }}>{TEXT_IN}</Typography>
                                  {isTimeZero(hr.clockInTime) ? (
                                    clockIn === hr_index ? (
                                      <CircularProgress size={25} />
                                    ) : (
                                      <Button
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          onClockBtnPressed({
                                            type: "CLOCK_IN",
                                            hours: hr,
                                            index: hr_index
                                          });
                                        }}
                                        sx={{
                                          textTransform: "none",
                                          backgroundColor: CLIENT_COLOR,
                                          boxShadow: "none",
                                          borderRadius: "10px",
                                          minWidth: "100px",
                                          color:
                                            checkBothTimeForOneClock &&
                                              checkInTimeForOneClock &&
                                              isTimeZero(hr.clockInTime)
                                              ? "white"
                                              : checkInTimeForOneClock && isTimeZero(hr.clockInTime)
                                                ? CLIENT_COLOR
                                                : "white"
                                        }}>
                                        {TEXT_CLOCK_IN}
                                      </Button>
                                    )
                                  ) : (
                                    <Button
                                      sx={{
                                        textTransform: "none",
                                        boxShadow: "none",
                                        backgroundColor: isTimeZero(hr.clockInTime)
                                          ? CLIENT_COLOR
                                          : "#e4e4e4",
                                        borderRadius: "10px",
                                        color: BIGrey,
                                        minWidth: "100px"
                                      }}
                                      onClick={(e) => e.stopPropagation()}>
                                      {hr.clockInTime}
                                    </Button>
                                  )}
                                </Stack>
                                <Stack>
                                  <Typography sx={{ color: BIGrey }}>{TEXT_OUT}</Typography>
                                  {isTimeZero(hr.clockOutTime) ? (
                                    clockOut === hr_index ? (
                                      <CircularProgress size={25} />
                                    ) : (
                                      <Button
                                        onClick={
                                          isTimeZero(hr.clockInTime)
                                            ? (e) => {
                                              e.preventDefault();
                                              e.stopPropagation();
                                            }
                                            : (e) => {
                                              e.preventDefault();
                                              e.stopPropagation();
                                              setClockout(hr_index);
                                              onClockBtnPressed({
                                                type: "CLOCK_OUT",
                                                hours: hr
                                              });
                                            }
                                        }
                                        sx={{
                                          boxShadow: "none",
                                          textTransform: "none",
                                          minWidth: "100px",
                                          backgroundColor: isTimeZero(hr.clockInTime) ? "#e4e4e4" : "white",
                                          color: isTimeZero(hr.clockInTime) ? BIGrey : CLIENT_COLOR,
                                          borderRadius: "10px",
                                          borderColor: CLIENT_COLOR
                                        }}
                                        variant={isTimeZero(hr.clockInTime) ? "contained" : "outlined"}>
                                        {isTimeZero(hr.clockInTime) ? "--:--" : TEXT_CLOCK_OUT}
                                      </Button>
                                    )
                                  ) : (
                                    <Button
                                      sx={{
                                        textTransform: "none",
                                        backgroundColor: isTimeZero(hr.clockInTime) ? CLIENT_COLOR : "#e4e4e4",
                                        color: BIGrey,
                                        borderRadius: "10px",
                                        minWidth: "100px",
                                        boxShadow: "none"
                                      }}
                                      onClick={(e) => e.stopPropagation()}>
                                      {hr.clockOutTime}
                                    </Button>
                                  )}
                                </Stack>
                                <Stack>
                                  <Typography sx={{ color: BIGrey }}>{TEXT_HOURS}</Typography>
                                  <Typography sx={{ mt: 0.5, fontWeight: "bold" }}>
                                    {hr?.hours == 0 ? "0.00" : hr?.hours}
                                  </Typography>
                                </Stack>
                              </Stack>
                            )
                        )}
                      </Stack>
                      <ArrowDropUpIcon
                        style={{
                          marginTop: "15px",
                          flexShrink: 0,
                          transform: activityIndex === index ? "rotate(0deg)" : "rotate(180deg)",
                          transition: "transform 0.3s ease"
                        }}
                      />
                    </div>

                    {/* Notes + images */}
                    <Collapse in={activityIndex === index} unmountOnExit>
                      {getUserHoursList().map(
                        (hr, hr_index) =>
                          hr.clientJobActivityId === act.clientActivityId && (
                            <div key={hr_index} style={{ padding: "0 12px 12px" }}>
                              <TextField
                                fullWidth
                                slotProps={{
                                  input: {
                                    rows: 4,
                                    multiline: true,
                                    inputComponent: "textarea"
                                  }
                                }}
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: "0",
                                    padding: " 5px 10px"
                                  },
                                  "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                                    border: "none"
                                  }
                                }}
                                rows={5}
                                onChange={(e) => addNotesHour(e, hr)}
                                style={{
                                  backgroundColor: "#e4e4e4",
                                  borderRadius: "10px",
                                  margin: "10px 0px"
                                }}
                                value={hr?.notes}
                                placeholder={PLACEHOLDER_SOMETHING}
                              />
                              <Grid size={12}>
                                <div style={{ overflowX: "auto", scrollbarWidth: "none", paddingTop: "8px", paddingBottom: "4px" }}>
                                <Stack
                                  direction={"row"}
                                  spacing={1}
                                  style={{ width: "max-content", minWidth: "100%" }}>
                                  <input
                                    type="file"
                                    hidden
                                    ref={imgRef}
                                    style={{ display: "none" }}
                                    accept="image/*"
                                    multiple
                                    onClick={(e) => e.stopPropagation()}
                                    onChange={(e) => handelImageChange(e, act)}
                                  />
                                  <div
                                    onClick={(e) => handelInputClick(e)}
                                    style={{
                                      margin: "0px",
                                      border: "1px solid #e4e4e4",
                                      borderRadius: "10px",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      display: "flex",
                                      height: "100px",
                                      width: "100px",
                                      minWidth: "100px"
                                    }}>
                                    <AddIcon />
                                  </div>
                                  <ImageMemoComponent
                                    setPictureIndex={setImageIndex}
                                    setPictureViewerOpen={setPictureViewerOpen}
                                    uploadedImageList={act?.pictureList}
                                    handleRemoveImage={handleRemoveImage}
                                    actIndex={index}
                                    setPictures={setPictures}
                                  />
                                </Stack>
                                </div>
                              </Grid>
                            </div>
                          )
                      )}
                    </Collapse>
                  </div>
                ))}
                <Button
                  fullWidth
                  disabled={!disableSaveBtn}
                  onClick={(e) => onSubmitPressed(e)}
                  style={{ color: disableSaveBtn ? "white" : selectedClientData?.AccentColor }}
                  sx={{
                    textTransform: "none",
                    color: "white",
                    borderRadius: "10px",
                    backgroundColor: disableSaveBtn ? selectedClientData?.AccentColor : null
                  }}>
                  {BUTTON_SUBMIT}
                </Button>
              </>
            )}
          </Stack>
        </Box>
      </Modal>
    </>
  );
}

const ImageList = ({
  uploadedImageList,
  handleRemoveImage,
  setPictureIndex,
  setPictureViewerOpen,
  actIndex,
  setPictures
}) => {
  const ImgUrl = (file) => {
    try {
      let url = URL.createObjectURL(file);
      return url;
    } catch (error) {
      return file;
    }
  };

  return uploadedImageList?.map((picture, index) => (
    <div style={{ position: "relative", height: "100px" }} key={index}>
      <img
        loading="lazy"
        onClick={(e) => {
          e.stopPropagation();
          setPictures(uploadedImageList);
          setPictureViewerOpen(true);
          setPictureIndex(index);
        }}
        src={picture?.fileUrl || ImgUrl(picture?.file)}
        alt={"NO data"}
        style={{
          cursor: "pointer",
          width: "100px",
          height: "100px",
          borderRadius: "10px"
        }}
      />
      <IconButton
        onClick={(e) => handleRemoveImage(e, actIndex, index)}
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          padding: "5px",
          backgroundColor: BILightGrey,
          color: "white"
        }}>
        <CloseIcon style={{ fontSize: "16px" }} />
      </IconButton>
    </div>
  ));
};

const ImageMemoComponent = memo(ImageList);

